// frontend/src/utils/variantNaming.js
// Canonical variant-name validation for all frontend save flows.

export const VARIANT_NAME_REGEX = /^[a-z][a-z0-9_]{0,29}$/;

export function sanitizeVariantName(value) {
    let sanitized = String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9_]/g, '');
    // Strip leading non-letter characters so the result passes isValidVariantName
    while (sanitized && !/^[a-z]/.test(sanitized)) {
        sanitized = sanitized.slice(1);
    }
    return sanitized.slice(0, 30);
}

export function isValidVariantName(name) {
    return typeof name === 'string' && VARIANT_NAME_REGEX.test(name);
}
